/**
 * This file is used to handle requests on all pages to ensure marketplace persistence.
 */

import { isTrue } from "../../lib/common";
import { popLorisMarketplaceLoader } from "../components/modal";
import { TryPersistMarketplaceLocation } from "../repos/locationSettings";
import { isStandaloneApp } from "./app-utilities";

const blockRefresh = isTrue(window['BlockRefresh']);

/**
 * Determines a safe refresh status.  Appends retry counts to url to ensure no infinite loops.
 * @returns
 */
const DetermineRefreshStatus = () => {

    const rule = {
        canRedirect: false,
        url: ''
    };

    const searchParams = new URLSearchParams(window.location.search);
        const retries = searchParams.get('retries');
        let retryCount = 0;
        if (!retries) {
            retryCount = 0;
        } else {
            retryCount = parseInt(retries, 10);
            if (isNaN(retryCount)) {
                retryCount = 0;
            }
        }
        searchParams.set('retries', (retryCount + 1).toString());

        if (retryCount <= 4) {
            rule.canRedirect = true;
            rule.url = window.location.pathname + '?' + searchParams.toString();
        }

        return rule;
}

/**
 * refreshes the current page or redirects if not allowed.
 */
const refreshPage = () => {
    if (blockRefresh) {
        popLorisMarketplaceLoader();
        location.href = "/loris-marketplace-store";
    } else {
        
        const refreshStatus = DetermineRefreshStatus();
        if (refreshStatus.canRedirect) {
            popLorisMarketplaceLoader();
            location.href = refreshStatus.url;
        }
        
    }
}


const tryPersist = async () => {

    const result = await TryPersistMarketplaceLocation();

    if (result.ServerWasUpdated) {
        // ui component to show to user
        refreshPage();
    }

}


if (isStandaloneApp()) {
     tryPersist();
}
